module.exports = __webpack_public_path__ + "static/media/zen.e6d08abf.jpg";